import React from "react"
import './index.css';
import Home from './routes/Home.js'
import About from './routes/About.js'
import Contact from './routes/Contact.js'
import Project from './routes/Project.js'


import {Route, Routes} from "react-router-dom";

function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/About" element={<About />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/Project" element={<Project />} />
    </Routes>
    </>
  );
}

export default App;
